import { normalizeText, toSingular } from '../utils/stringUtils';

const INDUSTRY_TERMS = {
  desodorante: [
    'antitranspirante', 'desodorizante', 'axilar', 'olor', 'sudor',
    'desodorantes', 'antitranspirantes', 'axilas', 'transpiracion',
    'roll on', 'stick', 'aerosol', 'body spray', 'antiperspirante',
    'deodorant', 'antitranspirant', 'spray', 'roll-on'
  ],
  bebe: [
    'infantil', 'niño', 'niños', 'bebes', 'baby', 'kids', 'delicado',
    'suave', 'sensible', 'pediatrico', 'pediatrica', 'infantiles',
    'bebe', 'babies', 'child', 'children', 'gentle', 'mild', 'soft',
    'delicate', 'sensitive', 'pediatric'
  ],
  jabon: [
    'jabon liquido', 'jabones', 'detergente', 'limpiador', 'gel',
    'espuma', 'soap', 'surfactante', 'lavado', 'limpieza', 'lavar',
    'limpiar', 'detergentes', 'limpiadores', 'geles', 'espumas',
    'liquid soap', 'hand soap', 'body wash', 'cleanser', 'washing'
  ],
  fabricar: [
    'producir', 'elaborar', 'preparar', 'formular', 'crear', 'hacer',
    'manufactura', 'desarrollo', 'fabricacion', 'produccion',
    'formulacion', 'manufacturing', 'proceso', 'elaboracion',
    'preparacion', 'formula', 'receta', 'recipe', 'make', 'create',
    'develop', 'formulate', 'preparation', 'production'
  ],
  acondicionador: [
    'acondicionamiento', 'suavizante', 'tratamiento', 'conditioner',
    'conditioning', 'softener', 'treatment', 'mascarilla', 'mask',
    'hair care', 'cuidado capilar', 'desenredante', 'detangler'
  ],
  surfactante: [
    'tensoactivo', 'detergente', 'limpiador', 'surfactantes',
    'tensioactivo', 'espumante', 'emulsionante', 'sulfato',
    'surfactant', 'cleanser', 'foaming agent', 'washing',
    'lauril', 'laureth', 'betaina', 'sls', 'sles', 'sulfate',
    'sulfonate', 'sulfonato', 'soap', 'jabon'
  ],
  emoliente: [
    'suavizante', 'hidratante', 'acondicionador', 'humectante',
    'emolientes', 'suavizantes', 'hidratantes', 'aceite', 'oil',
    'emoliencia', 'suavidad', 'moisturizer', 'cream', 'lotion',
    'crema', 'locion', 'balsamo', 'balm', 'butter', 'manteca',
    'emollient', 'moisturizing', 'softening'
  ],
  cosmetico: [
    'cosmetic', 'cuidado', 'care', 'belleza', 'beauty',
    'skin', 'piel', 'cabello', 'hair', 'facial', 'corporal', 'body',
    'personal care', 'cuidado personal', 'toiletries', 'grooming'
  ],
  maquillaje: [
    'makeup', 'make-up', 'cosmetic', 'cosmetico', 'base', 'foundation',
    'bases', 'primer', 'primers', 'fijador', 'fijadores', 'maquillajes',
    'cosmeticos', 'cosmetics', 'beauty', 'belleza', 'facial', 'face',
    'rostro', 'acabado', 'finish', 'textura', 'texture', 'pigmento',
    'pigment', 'color', 'colours', 'tono', 'shade', 'mate', 'matte',
    'brillo', 'shine', 'glow', 'luminoso', 'luminous', 'cobertura',
    'coverage', 'aplicacion', 'application'
  ],
  crema: [
    'cream', 'locion', 'lotion', 'emulsion', 'emulsión', 'balsamo',
    'balm', 'unguento', 'ointment', 'pomada', 'pomade', 'gel',
    'fluido', 'fluid', 'serum', 'suero', 'hidratante', 'moisturizer',
    'treatment', 'tratamiento', 'cuidado', 'care'
  ],
  facial: [
    'face', 'rostro', 'cara', 'facial', 'faciales', 'cutis', 'piel',
    'skin', 'dermis', 'epidermis', 'cutaneo', 'dermal', 'complexion',
    'tez', 'antiarrugas', 'antiage', 'rejuvenecedor', 'rejuvenating'
  ],
  cabello: [
    'hair', 'pelo', 'capilar', 'shampoo', 'champu', 'acondicionador',
    'conditioner', 'tratamiento', 'treatment', 'mascarilla', 'mask',
    'styling', 'peinado', 'fijacion', 'hold', 'brillo', 'shine',
    'volumen', 'volume', 'rizos', 'curls', 'liso', 'straight'
  ],
  proteccion: [
    'protection', 'protector', 'filtro', 'filter', 'uv', 'solar',
    'sun', 'spf', 'pantalla', 'screen', 'bloqueador', 'block',
    'fotoproteccion', 'photoprotection', 'radiacion', 'radiation'
  ]
};

export function processSearchTerms(query) {
  const terms = String(query)
    .split(/[\s,.\-]+/)
    .filter(t => t.length > 2)
    .map(t => normalizeText(t));

  const expanded = new Set();

  terms.forEach(term => {
    expanded.add(term);

    const singular = toSingular(term);
    expanded.add(singular);
    expanded.add(singular + 's');
    expanded.add(singular + 'es');

    Object.entries(INDUSTRY_TERMS).forEach(([key, synonyms]) => {
      const shouldInclude =
        key.includes(term) ||
        term.includes(key) ||
        synonyms.some(syn =>
          syn.includes(term) ||
          term.includes(syn) ||
          (syn.length > 4 &&
            term.length > 4 &&
            syn.substring(0, 5) === term.substring(0, 5))
        );

      if (shouldInclude) {
        synonyms.forEach(s => expanded.add(normalizeText(s)));
        expanded.add(key);
      }
    });

    terms.forEach(other => {
      if (other !== term) {
        expanded.add(`${term} ${other}`);
        expanded.add(`${other} ${term}`);
        expanded.add(`${term} de ${other}`);
        expanded.add(`${term} para ${other}`);
      }
    });
  });

  return Array.from(expanded);
}

export function normalizeProductData(product) {
  const normalized = {};

  Object.entries(product).forEach(([key, value]) => {
    if (typeof value === 'string') {
      normalized[key] = normalizeText(value);
    } else {
      normalized[key] = value;
    }
  });

  return normalized;
}

export function processProductText(product) {
  const weightedFields = [
    { field: 'name', weight: 3 },
    { field: 'applications', weight: 3 },
    { field: 'description', weight: 2 },
    { field: 'characteristics', weight: 2 },
    { field: 'benefits', weight: 2 },
    { field: 'sector', weight: 1 },
    { field: 'subsector', weight: 1 },
    { field: 'inci', weight: 1 }
  ];

  return weightedFields
    .map(({ field, weight }) => {
      const value = product[field];
      return typeof value === 'string'
        ? Array(weight).fill(normalizeText(value)).join(' ')
        : '';
    })
    .filter(Boolean)
    .join(' ');
}
